(function() {
  var __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  define('app/collections/NowPlayingCollection',['app/models/Song'], function(Song) {
    'use strict';
    var NowPlayingCollection;
    return NowPlayingCollection = (function(_super) {
      __extends(NowPlayingCollection, _super);

      function NowPlayingCollection() {
        return NowPlayingCollection.__super__.constructor.apply(this, arguments);
      }

      NowPlayingCollection.prototype.model = Song;

      NowPlayingCollection.prototype.comparator = function(item) {
        return -1 * item.get('created_at').unix();
      };

      return NowPlayingCollection;

    })(Backbone.Collection);
  });

}).call(this);

//# sourceMappingURL=NowPlayingCollection.js.map
;
